export interface InfoLink {
  id: number;
  label: string;
  link: string;
  image: string;
  description: string;
}

export const infoLinks: InfoLink[] = [
  {
    id: 2,
    label: 'Passport Scans',
    link: 'https://your-onedrive-link.com/passports',
    image: 'https://i.ibb.co/HQNMmJ0/oJY2K.png',
    description: 'Contains all scanned passport documents for quick access.',
  },
  {
    id: 1,
    label: 'XYZ',
    link: 'https://your-onedrive-link.com/xyz',
    image: 'https://i.ibb.co/yLvgVFw/xyz-cervena-RGB.png',
    description: 'This folder includes all the necessary files related to XYZ project.',
  },
  // Add more as needed
];